import { useState, useEffect } from 'react';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { Typography, InputAdornment, OutlinedInput, IconButton } from '@mui/material';

import { FormControl, Button } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Box } from '@mui/system';
import { KYBStepBanner } from './KYBStepBanner';
import { onlyNumber } from 'helpers/signInValidation';
import CloseIcon from '@mui/icons-material/Close';
import { Analytics } from 'lib/api';
import { KYX_ANALYTICS_EVENTS } from '../StartKYX';

const useStyles = makeStyles({
    dialogBody: {
        display: 'flex',
        flexDirection: 'row',
        minHeight: '600px',
        height: '100%'
    },
    content: {
        margin: '2em',
        width: '40em'
    },
    contentTitle: {
        fontWeight: '700!important'
    },
    phoneBox: {
        marginTop: '2em'
    },
    phoneInput: {
        width: '50%'
    },
    verifyButton: {
        color: 'white!important',
        borderRadius: '25px!important',
        padding: '.5em 3em!important',
        margin: '.5em!important',
        background: '#1BABE2!important'
    },
    inputFormControl: {
        background: '#FFFFFF',
        border: '1px solid #D8DDE2',
        boxSizing: 'border-box',
        borderRadius: '3px',
        marginTop: '10px',
        width: '100%!important',
        height: '40px'
    },
    contactInforFormLabel: {
        color: '#225384',
        fontWeight: 600
    },
    businessAdressBox: {
        display: 'grid',
        gridTemplateColumns: 'repeat(2,1fr)',
        rowGap: '1em',
        columnGap: '1em'
    },
    formControl: {
        width: '100%!important'
    },
    informationOptions: {
        marginTop: '3em',
        display: 'flex',
        justifyContent: 'space-between'
    },
    next: {
        color: 'white!important',
        borderRadius: '25px!important',
        marginLeft: '1em',
        padding: '.5em 3em!important'
    }
});

// accept an [optional] '-' sign only after 2nd digit
const einPattern = /^\d{2}-?\d{7}$/;

export const KYBSecondStep = ({ handleClose, activePage, handleInputChange, formValues, decreasePage, incrementPage }) => {
    const classes = useStyles();
    const [showWrongFormat, setShowWrongFormat] = useState(false);
    const [showEIN, setShowEIN] = useState(false);

    const verifyFormat = () => {
        let ein = formValues.ein;
        if (!einPattern.test(ein)) {
            setShowWrongFormat(true);
        } else {
            setShowWrongFormat(false);
        }
    };
    const incrementStep = () => {};

    const startThirdStep = () => {
        const body = {
            step: KYX_ANALYTICS_EVENTS.STEP_5,
            eventData: formValues
        };
        Analytics.createKYXEvent(body).catch(error => console.error(error));
        incrementPage();
    };

    useEffect(() => {
        document.getElementById('kyb-taxheader')?.scrollIntoView();
    }, []);

    return (
        <Box className={classes.dialogBody}>
            <KYBStepBanner activeStep={activePage} incrementStep={() => incrementStep()} />
            <Box className={classes.content}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Box>
                        <Typography variant="h5" className={classes.contentTitle} id="kyb-taxheader">
                            Tax Information
                        </Typography>
                        <Typography variant="subtitle1" style={{ color: '#A8B6C1' }}>
                            This will help us verify your business quickly
                        </Typography>
                    </Box>
                    <IconButton
                        edge="start"
                        color="inherit"
                        onClick={handleClose}
                        aria-label="close"
                        sx={{ alignSelf: 'flex-start' }}>
                        <CloseIcon />
                    </IconButton>
                </Box>

                <Box
                    sx={{
                        marginTop: { lg: '45px', md: '45px', sm: 'auto', xs: 'auto' }
                    }}
                    flexDirection="column">
                    <FormControl className={classes.formControl}>
                        <Typography variant="subtitle2">Business Employee Identification Number (EIN)</Typography>
                        <OutlinedInput
                            error={showWrongFormat}
                            name="ein"
                            id="ein"
                            onBlur={() => verifyFormat()}
                            className={classes.inputEINForm}
                            placeholder="EIN"
                            onChange={e => {
                                if (onlyNumber(e.target.value)) return handleInputChange(e);
                            }}
                            value={formValues.ein}
                            required
                            inputProps={{ maxLength: 9 }}
                            type={showEIN ? 'text' : 'password'}
                            size="small"
                            endAdornment={
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label="Toggle EIN visibility"
                                        onClick={() => setShowEIN(!showEIN)}
                                        edge="end">
                                        {!showEIN ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                            }
                        />
                    </FormControl>
                    {showWrongFormat ? (
                        <Typography sx={{ color: 'red', fontSize: '.75rem' }}>Please, enter a correct EIN.</Typography>
                    ) : null}
                </Box>
                <Box className={classes.informationOptions}>
                    <Button variant="text" onClick={() => decreasePage()}>
                        Back
                    </Button>
                    <Button
                        disabled={formValues.ein !== '' && einPattern.test(formValues.ein) ? false : true}
                        variant="contained"
                        onClick={() => startThirdStep()}>
                        Next
                    </Button>
                </Box>
            </Box>
        </Box>
    );
};
